<template>
  <div id="posts">
    <Navbar current="Posts" />
    <Sidebar />
    <Container col="col-12">
      <Header :isSubHeader="false" title="Posts" :iconClass="'fas fa-newspaper text-primary'"
        subtitle="Registro dos posts" :totalCount="totalItemsRegistered">
        <template v-slot:button>
          <router-link :to="`${$paths.posts.add}`" tag="a" class="btn lift btn-primary">
            <i class="fa-solid fa-circle-plus"></i>
            Adicionar
          </router-link>
        </template>
      </Header>

      <div class="card">
        <SearchBar @onSearch="search" />
        <LoadingContainer v-if="loadingItems" />
        <div v-else>
          <EmptyState v-if="!items.length" :totalItemsRegistered="totalItemsRegistered">
            <template v-slot:noItemsRegistered>
              <span class="fa-3x fa-solid fa-puzzle-piece text-black-50 mb-2"></span>
              <p>Nenhum conteúdo adicionado</p>
            </template>
          </EmptyState>
          <div v-else class="table-responsive">
            <table class="table table-sm table-nowrap card-table table-hover cursor-pointer">
              <TableHead :columns="columns" v-on:sort="sort" />
              <tbody class="list">
                <router-link tag="tr" v-for="(item, index) in items" v-bind:key="'tr-' + index"
                  :to="`${$paths.posts.detail}/${item.id}`">
                  <td>{{ item.title }}</td>
                  <td>{{ item.owner.name }}</td>
                  <td>{{ item.category?.title }}</td>
                  <td>
                    <span v-if="item.active" class="badge bg-light font-weight-bold">
                      <i class="fas fa-check"></i>
                      Aprovado
                    </span>
                    <span v-else class="badge bg-primary text-secondary font-weight-bold">
                      <i class="fas fa-clock"></i>
                      Pendente
                    </span>
                  </td>
                  <td class="text-end">
                    <time>{{
                      $moment(item.created_at).format("DD/MM/YYYY[ - ]HH:mm")
                    }}</time>
                  </td>
                </router-link>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row" v-if="!loadingItems">
        <div class="col-12 text-end">
          <span class="text-muted">mostrando <b>{{ countItemsShowing }}</b> de
            <b>{{ countItemsTotal }}</b> resultado(s)</span>
        </div>
      </div>
      <div class="row justify-content-center" v-if="!loadingItems && moreItemsToLoad">
        <div class="col-2">
          <FormButton label="Carregar mais" :loading="loadingMoreItems" @onClick="loadMore" />
        </div>
      </div>
    </Container>
  </div>
</template>
<script>
import PostsController from "./PostsController";
export default PostsController;
</script>
